/** Best-effort browser + platform strings for the System tab. Uses UA-CH where
 *  available, falls back to a light userAgent parse. No fingerprinting stored. */

interface UaInfo {
  browser: string;
  platform: string;
}

interface UADataBrand {
  brand: string;
  version: string;
}
interface NavigatorUAData {
  brands: UADataBrand[];
  platform: string;
  getHighEntropyValues(hints: string[]): Promise<{ platformVersion?: string }>;
}

export async function detectUa(): Promise<UaInfo> {
  const nav = navigator as Navigator & { userAgentData?: NavigatorUAData };
  const uaData = nav.userAgentData;
  if (uaData) {
    const brand = uaData.brands.find((b) => !/Not.?A.?Brand/i.test(b.brand));
    let platform = uaData.platform;
    try {
      const high = await uaData.getHighEntropyValues(["platformVersion"]);
      if (high.platformVersion) platform = `${uaData.platform} ${high.platformVersion.split(".")[0]}`;
    } catch { /* ignore */ }
    return {
      browser: brand ? `${brand.brand} ${brand.version}` : "Unknown",
      platform: platform || "Unknown",
    };
  }
  return parseUa(navigator.userAgent);
}

function parseUa(ua: string): UaInfo {
  const browser =
    /Firefox\/(\d+)/.exec(ua)?.[0] ??
    /Edg\/(\d+)/.exec(ua)?.[0]?.replace("Edg", "Edge ") ??
    /Chrome\/(\d+)/.exec(ua)?.[0]?.replace("/", " ") ??
    /Version\/(\d+).*Safari/.exec(ua)?.[0]?.replace(/Version\/(\d+).*/, "Safari $1") ??
    "Unknown";
  const platform =
    /Mac OS X ([0-9_]+)/.exec(ua)?.[0]?.replace(/_/g, ".").replace("Mac OS X", "macOS") ??
    /Windows NT ([0-9.]+)/.exec(ua)?.[0] ??
    /Android ([0-9.]+)/.exec(ua)?.[0] ??
    /(iPhone|iPad)/.exec(ua)?.[0] ??
    "Unknown";
  return { browser, platform };
}
